import Footer from '../components/Footer';

/**
 * Mount the Footer Mithril component into Flarum's pre-existing footer slot.
 *
 * Flarum 2.x renders an empty `<footer id="footer" class="App-footer">` as an
 * extension slot. We use `m.mount()` to take ownership of that subtree — from
 * here on, Mithril owns the diffing inside the footer.
 */
export default function addFooter() {
  const inject = () => {
    const target = document.getElementById('footer') || document.querySelector('.App-footer');
    if (!target) return;
    if (target.hasAttribute('data-be-mounted')) return;
    target.setAttribute('data-be-mounted', '1');
    target.setAttribute('role', 'contentinfo');
    m.mount(target, Footer);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject, {
      once: true
    });
  } else {
    inject();
  }
}
flarum.reg.add('glowingblue-demo', 'forum/extenders/addFooter', addFooter);